export default "__VITE_ASSET__CNx0k5y5__"